import { compose, withState, withHandlers } from 'recompose';

import ModaleWindowView from './ModaleWindowView';

export default compose()(ModaleWindowView);
